import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from '../Core/types';
import ids from '../QestIds';
//import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { PageSection } from '../../Layout';
import {
  BsEmbeddedMoistureContent,
  BsLaboratoryDensitySection,
  BsRetestSection,
  MeasurementSection,
  PreparationSection,
  ResultsSection,
} from './Bs/Sections';

const qestids = [ids.sandReplacement.BS_1377_9_Clause_2_2.rev1990];

let Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>
      <BsRetestSection />
      <BsLaboratoryDensitySection />
      <PageSection heading="Measurements">
        <MeasurementSection />
      </PageSection>
      <BsEmbeddedMoistureContent />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

Worksheet.qestIds = qestids;
const SandReplacementWorksheet = withInjectedProps(Worksheet);

export { SandReplacementWorksheet };
export default SandReplacementWorksheet;
